module.exports = __webpack_public_path__ + "static/media/Satisfaction.f46d484e.svg";